import React from 'react';
import PropTypes from 'prop-types';
// Styles
import styled from 'styled-components';
import TimePicker from 'react-time-picker';
import moment from 'moment';
import 'moment/locale/pt';
import { Icon } from 'components/atoms'

moment.locale('pt')

const ReactTimePicker = ({ className, isError, ...props }) => (
  <div className={`${className} custom-react-time-picker`}>
    <TimePicker
      {...props}
      locale="pt-PT"
      isError={isError}
      clearIcon={<Icon icon="fal fa-times" color="#000'" title="editar" height={14} />
      }
      hourAriaLabel="hora"
      hourPlaceholder="hora"
      minuteAriaLabel="minuto"
      minutePlaceholder="minutos"
      disableClock
    />
  </div>
)

ReactTimePicker.propTypes = {
  className: PropTypes.string,
  isError: PropTypes.bool,
};

ReactTimePicker.defaultProps = {
  className: '',
  isError: false,
}

const ReactTimePickerWithStyles = styled(ReactTimePicker)`
  width: 100%;

  .react-time-picker {
    font-size: ${props => props.theme.sizes.s};
    font-weight: ${props => props.theme.weight.light};
    width: 100%;

    &__wrapper {
      display:flex;
      justify-content: space-between;
      width: 100%;
      border: none;
      padding: ${props => props.theme.spacing.xs2} 0;
      border-bottom: 1px solid ${props => (props.isError ? props.theme.colors.danger : props.theme.colors.base)};
    }
    &__inputGroup {
      padding: 0;
    }
    &__inputGroup__leadingZero {
      display: inline-flex;
    }
    &__inputGroup__input:invalid {
      background: none;
      color: ${props => props.theme.colors.danger};
    }
    &__inputGroup__input {
      min-width: .54em;
      height: 100%;
      position: relative;
      padding: 0 1px;
      border: 0;
      background: none;
      font: inherit;
      box-sizing: initial;
      color: ${props => props.theme.colors.base};
      &:focus {
        outline: none;
      }
      &::placeholder {
        font-weight: ${props => props.theme.weight.light};
      }
    }


    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
      -moz-appearance:textfield; /* Firefox */
    }

    &__clear-button {
      border:none;
      background:none;
      cursor:pointer;
      padding: 4px 6px;
    }
  }
`;

ReactTimePickerWithStyles.propTypes = {
};


export default ReactTimePickerWithStyles;
